const INFO = {
	main: {
		title: "Hrithik's Portfolio",
		name: "Hrithik Agarwal",
		email: "agarwal.hrithik3961@gmail.com",
		logo: "../logo.png",
	},

	socials: {
		twitter: "https://twitter.com/imhrithikaggs",
		github: "https://github.com/Hrithik-3961",
		linkedin: "https://linkedin.com/in/hrithikagarwal-profile",
		instagram: "https://instagram.com/hrithik_agarwal_",
		facebook:
			"https://www.facebook.com/profile.php?id=100012243219830&mibextid=ZbWKwL",
	},

	homepage: {
		title: "Hrithik Agarwal",
		summary:
			"I am a skilled software engineer, proficient in Mobile app development with Kotlin and Java.",
		description:
			"Welcome to my portfolio website! Explore my projects, skills, and experience to discover how I can contribute to your software development needs.",
		quote: 'The Fact that"With a few GigaBytes of code, we hold the potential to revolutionize how people experience the world", fuels my drive to create valuable software applications.',
		resume_download_link:
			"https://drive.google.com/uc?id=17qF_wRqTlP2a62B-jxqHJnZHuzQ4O1Ka&export=download",
		resume_view_link: "https://drive.google.com/file/d/17qF_wRqTlP2a62B-jxqHJnZHuzQ4O1Ka/view"
	},

	about: {
		title: "Software Developer",
		description: [
			"With a passion for creating innovative and user-friendly mobile applications, I strive to deliver high-quality solutions that exceed expectations.",
			"Collaboration and effective communication are key aspects of my work ethic. I enjoy working closely with cross-functional teams, including designers, product managers, and QA engineers, to ensure smooth project execution and deliver exceptional results. My strong analytical skills and problem-solving mindset enable me to overcome challenges and find elegant solutions.",
			"I'm constantly seeking opportunities to grow and expand my skill set. I love taking on new challenges and exploring emerging technologies that can further enhance the apps I create.",
		],
	},

	project: {
		title: "Things I’ve made trying to put my dent in the universe.",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Here, you will find a collection of my latest and most notable projects which showcases my skills in creating engaging and feature-rich applications that deliver exceptional user experiences.",
	},

	projectsList: [
		{
			title: "Hand Cricket",
			description:
				"Developed an Android adaptation of the classic retro game, achieving a 4.0★ Play Store rating and 50,000+ downloads, demonstrating strong user engagement and product quality.",
			logos: [
				"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/android/android-original.svg",
				"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg",
			],
			link: "https://github.com/Hrithik-3961/HandCricket",
			implementation_link:
				"https://play.google.com/store/apps/details?id=com.Hand_Cricket",
		},

		{
			title: "SplitIt",
			description:
				"A modern cross-platform expense sharing app built with Flutter to easily track shared expenses, split bills, and settle balances effortlessly. Designed with a clean, intuitive interface for a seamless experience on both Android and iOS.",
			logos: [
				"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/android/android-original.svg",
				"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg",
			],
			link: "https://github.com/Hrithik-3961/SplitIt",
			implementation_link:
				"https://play.google.com/store/apps/details?id=com.hrithik.splitit",
		},

		{
			title: "Prevue",
			description:
				"An image editing app that lets users view, organize, and enhance their photos with essential editing tools, including cropping, filters, adjustments, and other basic image enhancements.",
			logos: [
				"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/android/android-original.svg",
				"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kotlin/kotlin-original.svg",
			],
			link: "https://github.com/Hrithik-3961/Prevue",
			implementation_link:
				"https://play.google.com/store/apps/details?id=com.hrithik.prevue",
		},

		{
			title: "Pingout",
			description:
				"A secure messaging application featuring end-to-end encryption, multi-level authentication, and advanced privacy measures to ensure confidential and protected communication between users.",
			logos: [
				"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/android/android-original.svg",
				"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg",
			],
			link: "https://github.com/Hrithik-3961/Pingout",
		},
		

		{
			title: "MediLink",
			description: "A blockchain-powered patient management system that securely stores and manages medical records, ensuring data integrity, transparency, and controlled access for authorized healthcare providers.",
			logos: [
				"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/solidity/solidity-original.svg",
				"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
			],
			link: "https://github.com/Hrithik-3961/MediLink",
		},

		{
			title: "Budgetixe",
			description:
				"An all-in-one personal finance web-app designed to help users track income and expenses, manage budgets, monitor spending habits, and stay on top of their day-to-day financial goals.",
			logos: [
				"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
				"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
			],
			link: "https://github.com/Hrithik-3961/budgetixe",
		},
	],

	experience: {
		title: "Navigating Challenges, Delivering Excellence",
		description:
			"With a passion for solving complex problems and a dedication to delivering exceptional results, I have successfully contributed to a range of projects. From startups to established companies, I have gained valuable experience in collaborating with diverse teams, navigating tight deadlines, and exceeding client expectations.",
	},

	experienceList: [
		{
			title: "ARRISE Solutions (India) Pvt. Ltd. (SDE 1)",
			company_url: "https://arrise.com/",
			date: "July 2025 - Present",
			description:
				"Engineered and optimized high-traffic real-time backend systems using Java, Spring Boot, Kafka, and PostgreSQL, processing 5,000+ events per second while ensuring concurrency, data consistency, and scalability.\nMentored junior developers and interns through onboarding and code reviews.",
		},
		{
			title: "ARRISE Solutions (India) Pvt. Ltd. (Associate Software Engineer)",
			company_url: "https://arrise.com/",
			date: "July 2024 - June 2025",
			description:
				"Developed two scalable real-time games supporting 6,000+ concurrent users.\nOptimized API performance by up to 3×, and built WebSocket systems handling channels with 10,000 concurrent clients."
		},
		{
			title: "ARRISE Solutions (India) Pvt. Ltd. (Backend Software Intern)",
			company_url: "https://arrise.com/",
			date: "January 2024 - June 2024",
			description:
				"Worked on Game Server Backend which conducts all the games and handles multiple client requests.\nDiagnosed and resolved 10+ critical production issues, improving system reliability and uptime.",
		},
		{
			title: "Genpreneur Technologies Pvt. Ltd. (Flutter Developer Intern)",
			company_url: "https://letsevolve.in/",
			date: "May 2023 - August 2023",
			description:
				"Built an app to integrate gamified elements and engaging user interfaces.\nConducted thorough testing and debugging to ensure the app's stability.",
		},
		{
			title: "AppyHigh Technology LLP (Android Developer Intern)",
			company_url: "https://appyhigh.com/",
			date: "June 2022 - September 2022",
			description:
				"Provided insights and suggestions to improve app features and user engagement.\nOrganized and prioritized work to complete assignments in an efficient manner.",
		},
		{
			title: "Unlearners Tech Pvt. Ltd. (Flutter Developer Intern)",
			company_url: "https://www.pebbl.life/",
			date: "May 2021 - April 2022",
			description:
				"Built an app to connect to the hardware product via Bluetooth and display its raw data visually.\nContributed to the project documentation, including technical specifications, user guides, and code documentation, for future maintenance and updates.",
		},
	],

	contact: {
		title: "Let's Get in Touch: Ways to Connect with Me",
		description_1:
			"Thank you for your interest in getting in touch with me. I welcome your feedback, questions, and suggestions. If you have a specific question or comment, please feel free to email me directly at",
		description_2:
			"I make an effort to respond to all messages within 24 hours, although it may take me longer during busy periods.",
	},
};

export default INFO;
